export default __webpack_public_path__ + "0316f327d78f610f0d3ff42461e03b6b.png";